import { ADD_COMPANY_LOT, ADD_USER_LOT } from 'ACTIONS';

export const addClassifiedToCount = company => (dispatch) => {
    if (company) {
        return dispatch({ type: ADD_COMPANY_LOT });
    }
    return dispatch({ type: ADD_USER_LOT });
};
